import { Link } from "react-router-dom";
import { rumors } from "@/mocks/rumors";
import ArticleCard from "@/components/feature/ArticleCard";
import { formatHeat } from "@/utils/format";

const stats = [
  { value: "2,400+", label: "累计爆料条目" },
  { value: "680+", label: "知情人线索" },
  { value: "20+", label: "每日更新" },
];

export default function Hero() {
  const featured = rumors[0];
  const sideList = rumors.slice(1, 4);
  const hotList = [...rumors].sort((a, b) => b.heat - a.heat).slice(0, 5);

  return (
    <section className="relative overflow-hidden bg-foreground-950">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20moody%20newsroom%20scene%20with%20layered%20crimson%20and%20amber%20light%20streaks%20across%20dark%20charcoal%20background%2C%20dramatic%20film%20grain%20texture%2C%20cinematic%20editorial%20photography%20with%20deep%20shadows%20and%20glowing%20highlights&width=1600&height=900&seq=neimu-hero-2026&orientation=landscape"
          alt="热点内幕爆料现场氛围背景图"
          title="热点内幕 - 独家爆料与一手信息"
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/85 via-foreground-950/75 to-foreground-950/90" />
      </div>

      <div className="container-editorial relative py-12 md:py-16 lg:py-20">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-12">
          <div className="lg:col-span-5 animate-fade-up">
            <span className="inline-flex items-center gap-2 rounded-full border border-accent-500/40 bg-accent-500/10 px-3.5 py-1.5 text-xs font-medium tracking-wide text-accent-300">
              <span className="h-1.5 w-1.5 rounded-full bg-accent-400 animate-pulse-dot" />
              知情人透露 · 一手信息持续更新
            </span>

            <h1 className="mt-5">
              <span className="block font-heading text-5xl font-black leading-none tracking-tight text-background-50 md:text-6xl">
                热点内幕
              </span>
              <span className="mt-4 block max-w-md font-heading text-xl font-semibold leading-relaxed text-background-100/85 md:text-2xl">
                把不便明说的关键线索，替你先看明白
              </span>
            </h1>

            <p className="mt-5 max-w-lg text-sm leading-relaxed text-background-100/70 md:text-base">
              聚焦热点内幕独家爆料，汇总知情人透露的小道消息与秘密流出内容。想看的内部消息、一手信息都在这里，带你抢先掌握事件背后不方便明说的部分。
            </p>

            <div className="mt-7 flex flex-col gap-3 sm:flex-row">
              <Link
                to="/rumors"
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-600 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-500"
              >
                <i className="ri-fire-line text-base" />
                浏览全部爆料
              </Link>
              <a
                href="#subscribe"
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-50/25 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-background-50/10"
              >
                <i className="ri-notification-3-line text-base" />
                订阅爆料提醒
              </a>
            </div>

            <dl className="mt-9 grid max-w-md grid-cols-3 gap-4 border-t border-background-50/15 pt-6">
              {stats.map((item) => (
                <div key={item.label}>
                  <dt className="font-heading text-2xl font-bold text-accent-300">{item.value}</dt>
                  <dd className="mt-1 text-xs text-background-100/60">{item.label}</dd>
                </div>
              ))}
            </dl>
          </div>

          <div className="lg:col-span-7 animate-fade-up" style={{ animationDelay: "120ms" }}>
            <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
              <div className="sm:col-span-2">
                <ArticleCard rumor={featured} variant="wide" headingLevel="h2" />
              </div>
              {sideList.map((item, index) => (
                <ArticleCard key={item.id} rumor={item} variant="list" index={index} headingLevel="h3" />
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className="relative border-t border-background-50/10 bg-foreground-950/60 backdrop-blur-sm">
        <div className="container-editorial py-4">
          <div className="flex flex-col gap-3 md:flex-row md:items-center md:gap-6">
            <span className="flex shrink-0 items-center gap-2 text-sm font-semibold text-primary-400">
              <i className="ri-flashlight-fill text-base" />
              今日热度榜
            </span>
            <ul className="flex flex-1 flex-col gap-2 md:flex-row md:items-center md:gap-5">
              {hotList.map((item, index) => (
                <li key={item.id} className="min-w-0 flex-1">
                  <Link
                    to={`/article/${item.id}`}
                    className="group flex items-center gap-3 md:block"
                  >
                    <span
                      className={`flex h-5 w-5 shrink-0 items-center justify-center rounded font-heading text-xs font-bold ${
                        index === 0
                          ? "bg-primary-600 text-background-50"
                          : "bg-background-50/10 text-background-100/70"
                      }`}
                    >
                      {index + 1}
                    </span>
                    <span className="min-w-0">
                      <span className="block truncate text-sm text-background-100/80 transition-colors group-hover:text-accent-300">
                        {item.title}
                      </span>
                      <span className="mt-0.5 hidden items-center gap-1 text-xs text-background-100/40 md:flex">
                        <i className="ri-fire-line" />
                        {formatHeat(item.heat)}
                      </span>
                    </span>
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}